import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    container: {
      marginTop: theme.spacing(2),
    },
    searchContainer: {
      marginBottom: theme.spacing(2),
    },
  })
);

export const tableStyles = {
  deleteIcon: {
    color: "#F44336",
  },

  actionButton: {
    fontSize: "12px",
    textTransform: "none",
    padding: "4px 12px",
    "&:hover": {
      backgroundColor: "rgba(108, 114, 147, 0.04)",
    },
  },

  deleteButton: {
    color: "#B91C1C",
    borderColor: "#EF4444",
    "&:hover": {
      borderColor: "#DC2626",
      backgroundColor: "rgba(239, 68, 68, 0.10)",
    },
  },
};

